module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chat-23228951612deeed2476db22dd7817e7.svg";